module.exports = __webpack_public_path__ + "img/guest-wifi.48bc5cfd.webp";